import { onError } from '@apollo/client/link/error';
import { ApolloError } from '@apollo/client';

export const createErrorLink = (onUnauthorized: () => void) =>
	onError(({ graphQLErrors }) => {
		if (graphQLErrors) {
			for (const err of graphQLErrors) {
				// Handle authentication errors
				if (
					err.extensions?.code === 'UNAUTHENTICATED' ||
					err?.message === 'Unauthenticated'
				) {
					onUnauthorized?.();
					break;
				}
			}
		}
	});

export const extractErrorMessage = (error: ApolloError): string => {
	if (error.graphQLErrors && error.graphQLErrors.length > 0) {
		const graphQLError = error.graphQLErrors[0];

		// Extract from originalError if it's a generic "Unexpected error."
		if (
			graphQLError.message === 'Unexpected error.' &&
			graphQLError.extensions?.originalError &&
			typeof graphQLError.extensions.originalError === 'object' &&
			'message' in graphQLError.extensions.originalError &&
			typeof graphQLError.extensions.originalError.message === 'string'
		) {
			return graphQLError.extensions.originalError.message;
		}

		return graphQLError.message;
	}

	return error.message;
};
